<div class="marquee-wrapper">
  <div class="marquee" [style.animation-duration]="speed + 's'">
    <ng-content></ng-content>
  </div>
</div>
